import { Link } from "react-router-dom";
import { Star, BookOpen } from "lucide-react";
import { imgUrl } from "../../lib/api";
import { SafeImg } from "./SafeImg";

export const Stars = ({ value = 4.5 }) => (
  <span className="inline-flex items-center gap-0.5" data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`w-3.5 h-3.5 ${i <= Math.round(value) ? "fill-bm-terra text-bm-terra" : "text-bm-line"}`} />
    ))}
  </span>
);

export const MagazineCard = ({ mag, showPublisher = true }) => {
  const comingSoon = mag.status === "coming_soon";
  return (
    <div className="group bm-card p-4 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-card-hover" data-testid={`magazine-card-${mag.slug}`}>
      <Link to={comingSoon ? "#" : `/magazines/${mag.slug}`} className="block">
        <div className="relative overflow-hidden rounded-lg bg-bm-sand/40 shadow-cover transition-shadow duration-300 group-hover:shadow-cover-hover">
          <SafeImg src={imgUrl(mag.cover_image)} alt={mag.title} loading="lazy" fallbackLabel={mag.title}
            className="w-full aspect-[3/4] object-cover transition-transform duration-300 group-hover:scale-[1.03]" data-testid={`cover-${mag.slug}`} />
          {mag.featured && !comingSoon && (
            <span className="absolute top-3 left-3 bg-bm-terra text-white text-[10px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full">
              New Issue
            </span>
          )}
          {comingSoon && (
            <span className="absolute top-3 left-3 bg-bm-ink text-bm-sand text-[10px] font-semibold uppercase tracking-[0.1em] px-3 py-1 rounded-full">
              Coming Soon
            </span>
          )}
        </div>
      </Link>
      <div className="pt-4">
        {showPublisher && mag.publisher_name && (
          <p className="text-xs uppercase tracking-[0.1em] font-semibold text-bm-muted mb-1 truncate" title={mag.publisher_name}>{mag.publisher_name}</p>
        )}
        <Link to={comingSoon ? "#" : `/magazines/${mag.slug}`}>
          <h3 className="font-display text-lg font-semibold text-bm-ink leading-snug line-clamp-2 group-hover:text-bm-terra transition-colors duration-200" title={mag.title}>
            {mag.title}
          </h3>
        </Link>
        <div className="flex items-center gap-2 mt-2">
          <Stars value={mag.rating} />
          <span className="text-xs text-bm-muted">({(mag.rating_count || 0).toLocaleString("en-IN")})</span>
        </div>
        <div className="flex items-center justify-between mt-3">
          {comingSoon ? (
            <span className="text-sm font-semibold text-bm-muted">Arriving soon</span>
          ) : mag.price_from != null ? (
            <span className="text-base font-semibold text-bm-ink">₹{mag.price_from.toLocaleString("en-IN")}<span className="text-xs font-normal text-bm-muted"> onwards</span></span>
          ) : <span />}
          {!comingSoon && (
            <Link to={`/magazines/${mag.slug}`} data-testid={`subscribe-${mag.slug}`}
              className="text-xs font-semibold uppercase tracking-[0.1em] text-bm-terra border border-bm-terra rounded-full px-4 py-1.5 hover:bg-bm-terra hover:text-white transition-colors duration-200">
              Subscribe
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export const ReadSampleLink = ({ slug }) => (
  <Link to={`/read/${slug}`} data-testid={`read-sample-${slug}`}
    className="inline-flex items-center gap-2 text-sm font-semibold text-bm-sand hover:text-white transition-colors duration-200">
    <BookOpen className="w-4 h-4" /> Read Sample
  </Link>
);
